import React, { FC } from 'react';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { Householder as HouseholderTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/Householder';
import { HOUSE_HOLDER, QueryResult } from './query';
import { useEmployeeQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { LoadingPage } from '../../Loading';
import { Form } from './Form';
interface HouseholderProps {
  question: Question;
}

export const Householder: FC<HouseholderProps> = ({ question }) => {
  const { loading, data } = useEmployeeQuery<QueryResult>(HOUSE_HOLDER);

  if (loading) return <LoadingPage />;
  return (
    <HouseholderTemplate question={question}>
      <Form householder={data?.request.profile?.householder} />
    </HouseholderTemplate>
  );
};
